export default "__VITE_ASSET__DOVsqst3__"